module.exports = __webpack_public_path__ + "img/photo.89f27eb0.jpg";